import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchCompetition = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, competitionId } = useParams();

  return useQuery({
    queryKey: ["competitions", sport, organizationId, competitionId],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/competitions/${competitionId}`,
      });

      return result?.data?.[0];
    },
    enabled: !!competitionId,
  });
};
